import { parseDateTime } from 'utils/dates/date.utils';

export const getForecastDateLabel = (dateTime, label) => {
  const forecastDate = parseDateTime(dateTime);

  if (!forecastDate || !label) return null;

  return `${forecastDate.toDateString()} ${label}`;
};
